export default function darkModeToggle() {
    return {
        theme: localStorage.getItem("theme") || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"),
        init() {
            this.applyTheme();
            window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
                if (!localStorage.getItem("theme")) {
                    this.theme = e.matches ? "dark" : "light";
                    this.applyTheme();
                }
            });
        },
        toggleTheme() {
            this.theme = this.theme === "dark" ? "light" : "dark";
            localStorage.setItem("theme", this.theme);
            this.applyTheme();
        },
        applyTheme() {
            document.documentElement.setAttribute("data-theme", this.theme);
        }
    };
}